import { createSlice } from "@reduxjs/toolkit";
import { getHorseProfile } from "appredux/actions/horseActions";
import { LoadingState } from "http/model";
import moment from "moment";

interface HorseProfileState {
  horseProfile: any;
  status: LoadingState;
}

const horseProfileSlice = createSlice({
  name: "horseProfile",
  initialState: {
    horseProfile: null,
    status: LoadingState.initial,
  } as HorseProfileState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getHorseProfile.fulfilled, (state, action) => {
      const diseases = action.payload.diseases || {};

      action.payload?.healthCertDocuments
        ?.filter((item: any) => item.USEF_status !== "rejected")
        .forEach((item: any) => {
          if (item.HCtype === "CVI") {
            diseases.CVI = item.proofDate;
            diseases["CVI-Exp"] = item.expiry;
          }

          if (item.HCtype === "EECVI") {
            diseases.EECVI = item.proofDate;
            diseases["EECVI-Exp"] = item.expiry;
          }

          if (["Vet Statement", "Veterinary Statement of Health"].includes(item.HCtype)) {
            diseases["Vet Statement"] = item.proofDate;
            diseases["Vet Statement-Exp"] = item.expiry;
          }

          if (item.HCtype === "ecc") {
            diseases.ecc = item.proofDate;
            diseases["ecc-Exp"] = item.expiry;
          }

          if (item.HCtype === "icue") {
            diseases.icue = item.proofDate;
            diseases["icue-Exp"] = item.expiry;
          }

          if (item.HCtype === "fhc") {
            diseases.fhc = item.proofDate;
            diseases["fhc-Exp"] = item.expiry;
          }
        });

      if (diseases.Coggins && !diseases["Coggins-Exp"]) {
        diseases["Coggins-Exp"] = moment.unix(diseases.Coggins).add(1, "year").unix();
      }

      state.horseProfile = {
        ...action.payload,
        diseases,
      };

      state.status = LoadingState.loaded;
    });
    builder.addCase(getHorseProfile.pending, (state, action) => {
      state.status = LoadingState.loading;
    });
    builder.addCase(getHorseProfile.rejected, (state, action) => {
      state.status = LoadingState.failed;
    });
  },
  selectors: {
    selectHorseProfile: (state: HorseProfileState) => state.horseProfile,
    selectHorseProfileLoading: (state: HorseProfileState) => state.status,
  },
});

export const { selectHorseProfile, selectHorseProfileLoading } = horseProfileSlice.selectors;

export default horseProfileSlice.reducer;
